import { addMargin, introductionDesc } from "../util/vendors";
import Siema from "siema";

export default {
	init() {

		//MAPA

		const setHeightPlace = () => {
			const contactPlace = document.querySelector(".pcontact__places");
			const contactPlaces = document.querySelectorAll(".pcontact__place")[0];
			const placeChildren = contactPlaces.children;
			let child1;
			let child2;

			for (let i = 0; i < placeChildren.length; i++) {
				child1 = placeChildren[0].offsetHeight;
				child2 = placeChildren[1].offsetHeight;
			}

			contactPlace.style.height = `${child1 + child2}px`;

			if (window.innerWidth > 480) {
				contactPlace.style.height = "auto";
			}
		};

		window.addEventListener("resize", setHeightPlace);

		if (window.innerWidth > 768) {
			addMargin(introductionDesc);
		} else {
			setHeightPlace();
		}

		const sectorsBtns = document.querySelectorAll("[data-sector-btn]");

		const sectorsActive = (e) => {
			e.preventDefault();

			for (var i = 0; i < sectorsBtns.length; i++) {
				sectorsBtns[i].classList.remove("pcontact__btn--active");
			}

			const clickedTab = e.currentTarget;
			clickedTab.classList.add("pcontact__btn--active");
			const sectorsTabs = document.querySelectorAll("[data-sector]");

			for (i = 0; i < sectorsTabs.length; i++) {
				sectorsTabs[i].classList.remove("pcontact__details--active");
			}

			const elementReference = e.currentTarget;
			const activeTabID = elementReference.getAttribute("data-sector-btn");
			const activeTab = document.querySelector(`[data-sector="${activeTabID}"`);
			const heightElement = activeTab.offsetHeight;
			contactDetail.style.height = `${heightElement}px`;
			activeTab.classList.add("pcontact__details--active");
		};

		for (let i = 0; i < sectorsBtns.length; i++) {
			sectorsBtns[i].addEventListener("click", sectorsActive)
		}

		const placesBtns = document.querySelectorAll("[data-place-btn]");

		const placesActive = (e) => {
			e.preventDefault();

			for (let i = 0; i < placesBtns.length; i++) {
				placesBtns[i].classList.remove("pcontact__btn--select");
			}

			const clickedTab = e.currentTarget;
			clickedTab.classList.add("pcontact__btn--select");

			const placesTabs = document.querySelectorAll("[data-place-details]");

			const elementReference = e.currentTarget;
			const activeTabID = elementReference.getAttribute("data-place-btn");

			for (i = 0; i < placesTabs.length; i++) {
				placesTabs[i].classList.remove("pcontact__place--active");
			}

			const activeTab = document.querySelector(`[data-place-details="${activeTabID}"`);
			activeTab.classList.add("pcontact__place--active");

			const setMarker = (latitude, longitude) => {
				marker = new google.maps.Marker({
					position: new google.maps.LatLng(latitude, longitude),
					map: map,
					icon: `${window.location.origin}/wp-content/themes/trzuskawica/src/images/marker.svg`
				});
			}

			switch (e.currentTarget.getAttribute("data-place-btn")) {
				case "Sitkówka":
					map.setCenter(new google.maps.LatLng(50.8061501, 20.5580461));
					setMarker(50.8061501, 20.5580461);
					break;
				case "Targowica":
					map.setCenter(new google.maps.LatLng(50.6889921, 16.9641882));
					setMarker(50.6889921, 16.9641882);
					break;
			}
		};

		for (var i = 0; i < placesBtns.length; i++) {
			placesBtns[i].addEventListener("click", placesActive)
		}

		const formLabels = document.querySelectorAll(".form-element");

		const removeTitle = () => {
			formLabels.forEach((label) => {
				label.addEventListener("blur", (e) => {
					e.currentTarget.parentElement.previousElementSibling.classList.remove("animate");
				});
			});
		};

		removeTitle();

		const animateLabel = () => {
			formLabels.forEach((label) => {
				label.setAttribute("autocomplete", "off");
				label.addEventListener("focus", (e) => {
					e.currentTarget.parentElement.previousElementSibling.classList.add("animate");
				});
			});
		};

		animateLabel();

		/* Kontakt */

		const changeForm = () => {
			const switchCheckbox = document.querySelector("#choose-form");
			const anonymousForm = document.querySelector(".pcontact__anonymous");
			switchCheckbox.addEventListener("change", (e) => {
				console.log(e, e.currentTarget.checked);
				if(e.currentTarget.checked) {
					anonymousForm.classList.add("pcontact__anonymous--show");
				} else {
					anonymousForm.classList.remove("pcontact__anonymous--show");
				}
			});
		}

		changeForm();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};